// Copyright (c) Cosmo Tech.
// Licensed under the MIT license.

// Available status
export const UPLOAD_FILE_STATUS_KEY = {
  DOWNLOADING: 'DOWNLOADING',
  UPLOADING: 'UPLOADING',
  DELETING: 'DELETING',
  READY_TO_DOWNLOAD: 'READY_TO_DOWNLOAD',
  READY_TO_DELETE: 'READY_TO_DELETE',
  READY_TO_UPLOAD: 'READY_TO_UPLOAD',
  EMPTY: 'EMPTY',
};
